'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-template-list.routes';

export class MailTemplateListComponent {
  constructor(Auth, DynamicPageService, dialogs) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;

    this.DynamicPageService.queryByType({type: 'mailblast-template'}, (data) => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve mailblast templates.")
    })

  }

  delete(page) {
    var that = this;

    var pageText = "<br/><br/><b>" + page.name + "</b><br/><p>" + page.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Mailblast Template?", "Do you really want to delete this mailblast template?" + pageText);
    dlg.result.then(() => {
      // OK delete it
      that.DynamicPageService.delete({id: page._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== page._id;
          });
        },
        err => {
          alert("Could not delete mailblast templates");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduu.messaging.template.list', [uiRouter])
  .config(routes)
  .component('mailTemplateList', {
    template: require('./mail-template-list.html'),
    controller: MailTemplateListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/template/list/mail-template-list.component.js